import type { IconProps } from "./icon-types";

/**
 * 수평선(minus). Checkbox의 indeterminate 상태 등에서 사용.
 * 16×16 그리드로 정규화(기존 Checkbox는 12×12였음).
 */
export const MinusIcon = (props: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
    <path d="M4 8H12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
